/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckylottery.vue?vue&type=template&id=534d2bc3&scoped=true"
import script from "./luckylottery.vue?vue&type=script&lang=js"
export * from "./luckylottery.vue?vue&type=script&lang=js"
import style0 from "./luckylottery.vue?vue&type=style&index=0&id=534d2bc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534d2bc3",
  null
  
)

export default component.exports